import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML to prevent XSS attacks
 * Allows only safe formatting tags and text-align styles
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'b',
      'i',
      'u',
      'a',
      'ul',
      'ol',
      'li',
      'p',
      'br',
      'strong',
      'em',
      'span',
      'h1',
      'h2',
      'h3',
      'div',
      'mark',
      's',
      'blockquote',
      'img',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style', 'src', 'alt'],
    FORBID_ATTR: ['onclick', 'onerror', 'onload'],
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed'],
    ALLOW_UNKNOWN_PROTOCOLS: true,
  });
}

/**
 * Replaces tokens with actual values for preview
 */
export function replaceTokens(
  html: string,
  values: Record<string, string>,
): string {
  let result = html;
  for (const [token, value] of Object.entries(values)) {
    result = result.replace(new RegExp(token, 'g'), value);
  }
  return result;
}
